import gql from 'graphql-tag';
export const adFileFragment = gql `
  fragment AdFile on AdFile {
    id
    adSetId
    file {
      ...File
    }
    size
  }
`;
//# sourceMappingURL=AdFile.js.map